// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { GlobalStyles } from './styles/GlobalStyles'; // We will create/update this
import { theme } from './styles/theme'; // We will create/update this

// --- Import Layouts ---
import DashboardLayout from './components/Layout/Layout';
import PublicLayout from './components/Layout/PublicLayout';

// --- Import your existing Page Components ---
import Home from './components/home/Home';
import Terms from './components/terms/Terms';
import Privacy from './components/privacy/Privacy';
import Contact from './components/contact/Contact';
import Features from './components/features/Features';
import Pricing from './components/Pricing/Pricing';
import About from './components/About/About';
import Booking from './components/Booking/Booking';
import LoginSignup from './components/LoginSignup/LoginSignup';
import Fnq from './components/Fnq/Fnq';

import NotFoundPage from './components/404page/Notfound';
import OrdersPage from './DashboardPages/components/pages/OrdersPage';
import UsersPage from './DashboardPages/components/pages/UsersPage';
import LoginRecordsPage from './DashboardPages/components/pages/LoginRecordsPage';

// --- CONTEXT and PROTECTION ---
import { AuthProvider } from './context/AuthContext'; // Import the provider
import ProtectedRoute from './context/ProtectedRoute'; // Import the protector
import AdminLoginPage from './DashboardPages/AdminLoginPage';
import ContactSubmissionsPage from './DashboardPages/components/pages/ContactSubmissionsPage';


function App() {
  return (
   <ThemeProvider theme={theme}>
          <GlobalStyles />
             <AuthProvider>
          <Router>
            <Routes>
          
              {/* --- Group 1: Your Main Site Routes (No Layout) --- */}
              <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/features" element={<Features />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<Fnq />} />
              <Route path="/login" element={<LoginSignup />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
      </Route>
                <Route path="/admin/login" element={<AdminLoginPage />} />
              {/* --- Group 2: Dashboard Routes --- */}
              {/* This parent route renders your Layout component */}
                <Route element={<ProtectedRoute />}>
              <Route path="/dash" element={<DashboardLayout />}>
                  {/* This makes `/dash` automatically load the orders page */}
                  <Route index element={<Navigate to="Orderspage" replace />} />
                  
                  {/* THESE ARE THE FIXED CHILD ROUTES */}
                  {/* The paths are RELATIVE (no leading "/") */}
                  <Route path="Orderspage" element={<OrdersPage />} />
                  <Route path="userspage" element={<UsersPage />} />
                  <Route path="loginrecord" element={<LoginRecordsPage />} />
                   <Route path="contactusrecord" element={<ContactSubmissionsPage />} />

              </Route>
            </Route>
              {/* --- Catch-all 404 Route --- */}
              <Route path="*" element={<NotFoundPage />} />
      
            </Routes>
          </Router>
          </AuthProvider>
      </ThemeProvider>
  );
}

export default App;